import { ConsolidatedLocationView } from '@mark43/cad-api';
import { LocationStoreView } from '../../location/types';
import { getCrossStreetsString } from './location-display';

export function getLocationSummaryFirstLineText(
    consolidatedLocationView?: ConsolidatedLocationView | LocationStoreView | null
): string {
    if (
        consolidatedLocationView &&
        'isForcedResult' in consolidatedLocationView &&
        !!consolidatedLocationView.isForcedResult
    )
        return consolidatedLocationView.streetAddress ?? '';
    if (!consolidatedLocationView) return '';
    const address = [
        consolidatedLocationView.placeName,
        consolidatedLocationView.streetAddress?.replace(' & ', '/') ?? '',
    ]
        .filter((x) => !!x)
        .join(', ');
    if (consolidatedLocationView.type === 'INTERSECTION' && consolidatedLocationView.resolverSource !== 'GEO_ALIAS') {
        return getCrossStreetsString(consolidatedLocationView);
    }
    if (consolidatedLocationView.type === 'RANGE') {
        return [consolidatedLocationView.rangeName, address].filter((x) => !!x).join(' ');
    }
    return address;
}

export function getLocationSummarySecondLineText(
    consolidatedLocationView: ConsolidatedLocationView | null | undefined
): string {
    if (!consolidatedLocationView) return '';
    if (!consolidatedLocationView.areCoordinatesVerified) return 'Forced Location';
    return [
        [consolidatedLocationView.locality, consolidatedLocationView.adminArea1]
            .filter((str) => !!str)
            .join(', '),
        consolidatedLocationView.postalCode,
    ]
        .filter((str) => !!str)
        .join(' ');
}

export function getLocationSummaryThirdLineText(
    consolidatedLocationView: ConsolidatedLocationView | null | undefined
): string {
    if (!consolidatedLocationView) return '';
    // If this location is an intersection, we return empty string because the cross streets
    // will be shown on the first line
    if (consolidatedLocationView.type === 'INTERSECTION') return '';
    return getCrossStreetsString(consolidatedLocationView);
}
